var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "h5-page" },
    [
      _c("div", { staticClass: "h5-header" }, [_vm._v("我的伙伴")]),
      _c(
        "div",
        { staticClass: "h5-body" },
        [
          _c("a-list", {
            attrs: {
              loading: _vm.loading,
              "data-source": _vm.partners,
              locale: { emptyText: "暂无已绑定的伙伴" },
            },
            scopedSlots: _vm._u([
              {
                key: "renderItem",
                fn: function (item) {
                  return _c(
                    "a-list-item",
                    {},
                    [
                      _c(
                        "a-list-item-meta",
                        {
                          attrs: {
                            description:
                              "绑定时间：" + (item.createTime || "-"),
                          },
                        },
                        [
                          _c(
                            "span",
                            { attrs: { slot: "title" }, slot: "title" },
                            [
                              _vm._v(
                                "\n            " +
                                  _vm._s(
                                    item.partnerName ||
                                      "伙伴" + item.partnerTenantId
                                  ) +
                                  "\n            "
                              ),
                              item.archiveType === "供应商"
                                ? _c(
                                    "a-tag",
                                    {
                                      staticStyle: { "margin-left": "8px" },
                                      attrs: { color: "green" },
                                    },
                                    [_vm._v("供应商")]
                                  )
                                : item.archiveType === "客户"
                                ? _c(
                                    "a-tag",
                                    {
                                      staticStyle: { "margin-left": "8px" },
                                      attrs: { color: "blue" },
                                    },
                                    [_vm._v("客户")]
                                  )
                                : _vm._e(),
                            ],
                            1
                          ),
                          _c("a-avatar", {
                            staticStyle: { "background-color": "#1890ff" },
                            attrs: { slot: "avatar", icon: "shop" },
                            slot: "avatar",
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                },
              },
            ]),
          }),
        ],
        1
      ),
      _c("h5-tab-bar", { attrs: { active: "partners" } }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }